/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const SessionFrequencyEnum = {
    Weekly: 'WEEKLY',
    Every2Weeks: 'EVERY_2_WEEKS',
    Every3Weeks: 'EVERY_3_WEEKS',
    Every4Weeks: 'EVERY_4_WEEKS',
    ByArrangement: 'BY_ARRANGEMENT',
    Other: 'OTHER'
} as const;
export type SessionFrequencyEnum = typeof SessionFrequencyEnum[keyof typeof SessionFrequencyEnum];

